"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/index.js";
import * as React from "react";
const DropdownMenuContext = React.createContext({
    isOpen: false,
    setIsOpen: () => { },
});
export function DropdownMenu({ children }) {
    const [isOpen, setIsOpen] = React.useState(false);
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            const target = event.target;
            if (!target.closest("[data-dropdown-menu]")) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("click", handleClickOutside);
            return () => document.removeEventListener("click", handleClickOutside);
        }
    }, [isOpen]);
    return (_jsx(DropdownMenuContext.Provider, { value: { isOpen, setIsOpen }, children: _jsx("div", { className: "relative", "data-dropdown-menu": true, children: children }) }));
}
export function DropdownMenuTrigger({ children, asChild }) {
    const { isOpen, setIsOpen } = React.useContext(DropdownMenuContext);
    const handleClick = () => {
        setIsOpen(!isOpen);
    };
    if (asChild) {
        if (React.isValidElement(children)) {
            return React.cloneElement(children, {
                onClick: handleClick,
            });
        }
    }
    return _jsx("button", { onClick: handleClick, children: children });
}
export function DropdownMenuContent({ children, align = "start", className }) {
    const { isOpen } = React.useContext(DropdownMenuContext);
    if (!isOpen)
        return null;
    const alignmentClasses = {
        start: "left-0",
        center: "left-1/2 -translate-x-1/2",
        end: "right-0",
    };
    return (_jsx("div", { className: cn("bg-popover text-popover-foreground absolute top-full z-50 mt-1 min-w-32 overflow-hidden rounded-md border p-1 shadow-md", "border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800", alignmentClasses[align], className), children: children }));
}
export function DropdownMenuItem({ children, onClick, className }) {
    const { setIsOpen } = React.useContext(DropdownMenuContext);
    const handleClick = () => {
        onClick?.();
        setIsOpen(false);
    };
    return (_jsx("div", { className: cn("hover:bg-accent hover:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50", "hover:bg-gray-100 dark:hover:bg-gray-700", className), onClick: handleClick, children: children }));
}
export function DropdownMenuSeparator({ className }) {
    return _jsx("div", { className: cn("bg-muted -mx-1 my-1 h-px", "bg-gray-200 dark:bg-gray-600", className) });
}
